import { useAtom, useAtomValue } from 'jotai';

import {
  isCancelRecordingConfirmationShownAtom,
  isRecorderSheetOpenAtom,
  mediaBlobUrlAtom,
  recorderStatusAtom,
  uiStatusAtom,
  voiceNotesSourceAtom,
} from '../state';

/**
 * Hook for accessing UI-related Videa Notes atoms.
 * Groups sheet state, UI status, and recorder status.
 */
export const useVideaNotesUIAtoms = () => {
  const [uiStatus, setUiStatus] = useAtom(uiStatusAtom);
  const [isSheetOpen, setIsSheetOpen] = useAtom(isRecorderSheetOpenAtom);
  const [isCancelRecordingConfirmationShown, setIsCancelRecordingConfirmationShown] =
    useAtom(isCancelRecordingConfirmationShownAtom);
  const voiceNotesSource = useAtomValue(voiceNotesSourceAtom);
  const recorderStatus = useAtomValue(recorderStatusAtom);
  const [mediaBlobUrl] = useAtom(mediaBlobUrlAtom);

  return {
    // UI status
    uiStatus,
    setUiStatus,

    // Sheet state
    isSheetOpen,
    setIsSheetOpen,

    // Cancel confirmation
    isCancelRecordingConfirmationShown,
    setIsCancelRecordingConfirmationShown,

    // Voice notes source
    voiceNotesSource,

    // Recorder
    recorderStatus,
    mediaBlobUrl,
  };
};
